import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { txt } from 'libs/i18n';
import { useSignals } from '@preact/signals-react/runtime';
import { savingStateSignal } from '../../signalsStore/savingState';
import styles from './style.module.less';
const SavingStatus = () => {
    useSignals();
    if (savingStateSignal.value === 'retrying') {
        return (_jsxs("div", { className: styles.savedLabel, children: [_jsx("strong", { children: txt('saveFailed') }), txt('retrying')] }));
    }
    if (savingStateSignal.value === 'failed-no-retry') {
        return (_jsx("div", { className: styles.savedLabel, children: _jsx("strong", { children: txt('saveFailed') }) }));
    }
    if (savingStateSignal.value === 'unsaved') {
        return (_jsx("div", { className: styles.savedLabel, children: _jsx("strong", { children: txt('unsaved') }) }));
    }
    return (_jsx("div", { className: styles.savedLabel, children: savingStateSignal.value === 'saved' ? txt('saved') : txt('saving') }));
};
export default SavingStatus;
